import React from "react";

export default Form =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = { uiError: "", successMessage: undefined };
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.backendError !== nextProps.backendError) {
        this.setState({ uiError: nextProps.backendError });
      }
      if (this.props.disabled && !nextProps.disabled) {
        // Save operation has been completed.
        let backendError = this.state.uiError;
        if (this.props.backendError !== nextProps.backendError) {
          // A new backend error has been dispatched
          backendError = nextProps.backendError;
        }
        if (backendError === "") {
          // There was no error, so we can display the success message.
          this.setState({ successMessage: "Changes have been saved!" });
        }
      }
    }

    render() {
      const formProps = {
        messagesProps: {
          uiError: this.state.uiError,
          clearUIError: () =>
            this.setState({ uiError: "", successMessage: undefined }),
          onUIError: uiError => this.setState({ uiError }),
          successMessage: this.state.successMessage,
        },
        ...this.props,
      };
      return <Form {...formProps} />;
    }
  };



// WEBPACK FOOTER //
// ./src/sc/ui/components/hoc/formWithMessages.js